
document.addEventListener('click', event => {
  const header = event.target.closest('.expertise-areas .accordion-header')
  if (!header) return

  const item = header.closest('.accordion-item')
  const group = header.closest('.accordion')
  const open = !item.classList.contains('open')

  group.querySelectorAll('.accordion-item.open').forEach(other => {
    if (other !== item) setOpen(other, false)
  })

  setOpen(item, open)
})

function setOpen(item, open) {
  item.classList.toggle('open', open)

  const header = item.querySelector('.accordion-header')
  if (header) header.setAttribute('aria-expanded', open ? 'true' : 'false')
}
